/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../../components/Modal';
import Guide from '../../../components/Guide';
import useForm from '../../../hooks/useForm';
import Input from '../../../components/Input';
import IconButton from '../../../components/Button/IconButton';
import SearchIcon from "../../../assets/images/icon/search-icon-3.svg";
import { getEmployeeSearch } from '../../../apis/employee/employee';
import { ControlTable } from '../../../components/Table';
import { isEmpty } from '../../../utils/lodashExtend';
import DeleteIcon from "../../../assets/images/icon/delete-icon.svg";
import Button from '../../../components/Button';

const CollaborationToEmployees = ({
  open,
  setOpen,
  selectedList: _selectedList = [],
  form = {},
  key = "collaborationToEmployees",
  submit = () => { },
}) => {

  const [employees, setEmployees] = useState([]);
  const [list, setList] = useState([]);

  const [searchFields] = useState([
    { title: "이름", key: "name" },
    { title: "회사명", key: "company.name" },
    { title: "직급", key: "companyGrade.name" }
  ]);

  const fields = [
    { title: "이름", key: "name" },
    { title: "회사명", key: "company.name" },
    // {
    //   title: "접근권한", type: "select",
    //   key: "role", options: { list: ROLE_TYPES },
    //   onChange: (e, data) => {
    //     list.find(f => f.idx === data.idx).role = e.target.value;
    //     setList([...list]);
    //   }
    // },
    {
      title: "", key: "idx",
      onValue: (value, field, data) => {
        return (
          <IconButton
            icon={DeleteIcon}
            className="delete-btn"
            onClick={() => deleteAccess(data)}
          />
        );
      }
    },
  ];

  const deleteAccess = (data) => {
    const deletedIdx = list.findIndex(f => f.idx === data.idx);
    list.splice(deletedIdx, 1);
    setList([...list]);
  };


  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
  };

  const searchSubmit = (data) => {
    getEmployeeSearch("global", data)
      .then(res => {
        setEmployees(res.data);
      });
  };

  const {
    errors,
    values,
    handleOnChange,
    handleSubmit,
    setValidateFields,
  } = useForm({
    keyword: "",
    type: 2
  },
    searchSubmit,
  );

  useEffect(() => {
    setValidateFields([
      { label: '검색어', key: 'keyword', type: 'inpyut', min: 2, validators: ['required'] },
    ]);
  }, []);

  useEffect(() => {
    if (form && key && form[key]) {
      setList(form[key]);
    }
  }, [form]);


  const _submit = () => {
    submit(list);
  };

  const handleOnSelect = (data) => {
    const checkedData = list.find(f => f.idx === data.idx);

    if (checkedData) {
      const deletedIdx = list.findIndex(f => f.idx === data.idx);
      list.splice(deletedIdx, 1);
    } else {
      list.push(data);
    }

    setList([...list]);
  };



  const rowActiveAction = (data) => {
    return list.find(f => f.idx === data.idx);
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
      className="search-manager"
    >
      <ModalHeader>협업 가능자 설정</ModalHeader>
      <Guide
        textAlign="center"
        children={
          <div className="guide-text-wrap" style={{
            display: "inline-block",
            verticalAlign: "middle",
          }}>
            <p>이름을 두글자 이상 검색 해주세요.</p>
            <p></p>
          </div>
        }
      />

      <form onSubmit={handleSubmit}>
        <div className="request-container">
          <div className="reqeust-filter-wrap">
            <Input
              name="keyword"
              value={values.keyword}
              placeholder="이름 검색(2글자 이상)"
              onChange={handleOnChange}
            />
            <IconButton
              icon={SearchIcon}
              onClick={handleSubmit}
            />
            {errors && <p className="error-message">{errors.keyword}</p>}
          </div>
        </div>
      </form>
      <div>
        <div className="mt-10">
          <ControlTable
            isHideControlHeader
            style={{ maxHeight: "300px" }}
            fields={searchFields}
            list={employees}
            className="search-table"
            noDataText={"검색된 직원이 없습니다."}
            onSelect={handleOnSelect}
            rowActiveAction={rowActiveAction}
          />
        </div>

        {(!isEmpty(employees) || !isEmpty(list)) && (
          <ControlTable
            isHideControlHeader
            style={{ maxHeight: "300px" }}
            fields={fields}
            list={list}
            className="search-table"
            noDataText={"선택된 직원이 없습니다."}
          />
        )}
      </div>
      <div className="submit-button-wrap">
        <Button color={"text"} onClick={cancel} className="float-right">
          취소
        </Button>
        <Button className="float-right" onClick={_submit}>
          설정
        </Button>
      </div>
    </Modal>
  );
};

export default CollaborationToEmployees;